// utils/generatePanelRoutes.js
import { componentsMap } from "../../src/components/config/componentsMap";

export const generatePanelRoutes = (permissions = []) => {
  return permissions.map(({ key }) => {
    const Component = componentsMap[key];
    return {
      path: key,
      element: Component ? <Component /> : <div>Error: Component not found for "{key}"</div>,
    };
  });
};
